import React from "react";

import AdminFunctions from "../../../components/AdminFunctions/AdminFunctions";

const DashboardView = ({
  functions,
  selectedProject,
  activeProject,
  onBackToProjects,
}) => {
  return (
    <div className="dashboard-section">
      <div className="dashboard-header">
        <div className="dashboard-breadcrumb">
          <span className="breadcrumb-link" onClick={onBackToProjects}>
            Projects
          </span>

          {selectedProject !== "" && (
            <>
              <span className="breadcrumb-separator">/</span>

              <span className="breadcrumb-current">
                {activeProject?.projectName || "Project"}
              </span>
            </>
          )}
        </div>

        <div className="dashboard-header-row">
          <h2 className="dashboard-titleMain">Project Overview</h2>

          {selectedProject !== "" && activeProject?.siteLocation && (
            <span className="dashboard-chip">{activeProject.siteLocation}</span>
          )}
        </div>
      </div>

      <AdminFunctions functions={functions} selectedProject={selectedProject} />
    </div>
  );
};

export default DashboardView;
